import { createContext } from 'react';
import { BaseContextType } from '#base/contexts/BaseContextType';

const BaseContext = createContext<BaseContextType>(null);

export { BaseContext };
